export const ARTIST_LANGUAGE_OPTIONS = [
  "Hindi",
  "English",
  "Punjabi",
  "Gujarati",
  "Marathi",
  "Bengali",
  "Tamil",
  "Telugu",
  "Kannada",
  "Malayalam",
  "Other",
];

export function getArtistLanguageSelection(profileLanguages = [], answers = {}) {
  const savedProfileLanguages = Array.isArray(profileLanguages) ? profileLanguages : [];
  const savedAnswers = Array.isArray(answers.languages) ? answers.languages : null;
  const storedLanguages = savedAnswers ?? savedProfileLanguages;
  const selected = storedLanguages.filter((language) => ARTIST_LANGUAGE_OPTIONS.includes(language));
  const profileCustomLanguages = savedProfileLanguages.filter(
    (language) => !ARTIST_LANGUAGE_OPTIONS.includes(language),
  );
  const otherText = answers.languages_other || profileCustomLanguages.join(", ");

  if ((profileCustomLanguages.length || otherText) && !selected.includes("Other")) {
    selected.push("Other");
  }
  return { selected, otherText };
}

export function getProfileLanguages(selectedLanguages = [], otherText = "") {
  const profileLanguages = selectedLanguages.filter((language) => language !== "Other");
  if (selectedLanguages.includes("Other")) {
    profileLanguages.push(...otherText.split(",").map((language) => language.trim()).filter(Boolean));
  }
  return [...new Set(profileLanguages)];
}
